import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { medicationApi } from "../../../api/y-te/medicationApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eMedicationActionTypeIds,
	IMedicationDeleteStart,
	IMedicationLoadDangKyStart,
	IMedicationLoadDetailStart,
	IMedicationLoadStart,
	IMedicationSaveDangKyStart,
	IMedicationSaveStart
} from "../../action-types/y-te/IMedicationActionTypes";
import { medicationActions } from "../../actions/y-te/medicationActions";

export function* medicationSaga(): any {
	yield takeLatest(eMedicationActionTypeIds.LOAD_START, loadMedicationWorker)
	yield takeLatest(eMedicationActionTypeIds.LOAD_DETAIL_START, loadMedicationDetailWorker)
	yield takeLatest(eMedicationActionTypeIds.LOAD_DANGKY_START, loadMedicationDangKyWorker)
	yield takeEvery(eMedicationActionTypeIds.SAVE_START, saveMedicationWorker)
	yield takeEvery(eMedicationActionTypeIds.DELETE_START, deleteMedicationWorker)
	yield takeEvery(eMedicationActionTypeIds.SAVE_DANGKY_START, saveMedicationDangKyWorker)
}

function* loadMedicationWorker(action: IMedicationLoadStart): any {
	const res: IBaseResponeModel = yield call([medicationApi, medicationApi.SelectAllCheckDangKy], action.payload)
	if (res.is_success) {
		yield put(medicationActions.loadMedicationSuccess(res.data || []))
	} else {
		yield put(medicationActions.loadMedicationError(res.message || "Không tải được danh sách thuốc"))
	}
}

function* loadMedicationDetailWorker(action: IMedicationLoadDetailStart): any {
	const res: IBaseResponeModel = yield call([medicationApi, medicationApi.SelectById], action.payload)
	if (res.is_success) {
		if (res.data) {
			yield put(medicationActions.loadMedicationDetailSuccess(res.data))
		}
	} else {
		yield put(medicationActions.loadMedicationDetailError(res.message || "Không tải được chi tiết thuốc"))
	}
}

function* loadMedicationDangKyWorker(action: IMedicationLoadDangKyStart): any {
	const res: IBaseResponeModel = yield call([medicationApi, medicationApi.SelectAllCheckDangKy], action.payload)
	if (res.is_success) {
		yield put(medicationActions.loadMedicationDangKySuccess(res.data || []))
	} else {
		yield put(medicationActions.loadMedicationDangKyError(res.message || "Không tải được danh sách thuốc"))
	}
}

function* saveMedicationWorker(action: IMedicationSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([medicationApi, medicationApi.Update], action.payload);
	} else {
		res = yield call([medicationApi, medicationApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(medicationActions.saveMedicationSuccess(is_update))
	} else {
		yield put(medicationActions.saveMedicationError(res.message || "Không lưu được thuốc"))
	}
}

function* deleteMedicationWorker(action: IMedicationDeleteStart): any {
	const res: IBaseResponeModel = yield call([medicationApi, medicationApi.Delete], action.payload)
	if (res.is_success) {
		yield put(medicationActions.deleteMedicationSuccess())
	} else {
		yield put(medicationActions.deleteMedicationError(res.message || "Không xoá được thuốc"))
	}
}

function* saveMedicationDangKyWorker(action: IMedicationSaveDangKyStart): any {
	const res: IBaseResponeModel = yield call([medicationApi, medicationApi.InsertMultiple], action.payload)
	if (res.is_success) {
		yield put(medicationActions.saveMedicationDangKySuccess())
	} else {
		yield put(medicationActions.saveMedicationDangKyError(res.message || "Không lưu được đăng ký thuốc với cơ sở"))
	}
}
